"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchSpecificity = exports.calculateSpecificity = void 0;
var tslib_1 = require("tslib");
var css_selector_tokenizer_1 = require("css-selector-tokenizer");
var native_pseudo_elements_set_1 = require("../utils/native-pseudo-elements-set");
/*
    Here we assume that stylable pseudo-elements have specificity of class,
    it's true for most cases but it dose not support @custom-selector and mapped selectors (-st-global)
*/
var categorizeSelectorNodes = function (nodes, options) {
    return nodes
        .map(function (node) {
        switch (node.type) {
            case 'universal':
            case 'spacing':
            case 'operator':
            case 'comment':
            case 'invalid':
                return '';
            case 'element':
                return 'element';
            case 'pseudo-element':
                if (options.stylableMode && !native_pseudo_elements_set_1.nativePseudoElementsSet.has(node.name)) {
                    /*
                        this is a very simplified approach
                        it dose not take into account custom selectors
                    */
                    return 'class';
                }
                return 'element';
            case 'class':
            case 'pseudo-class':
            case 'attribute':
                return 'class';
            case 'id':
                return 'id';
            case 'nested-pseudo-class':
                if (node.nodes.length > 1) {
                    throw Error("Too many selectors inside nested pseudo-class ".concat(node.name));
                }
                return categorizeSelectorNodes(node.nodes[0].nodes, options);
        }
    })
        .reduce(
    // flatten
    function (previous, current) { return (current ? previous.concat(current) : previous); }, []);
};
var countNodeTypes = function (nodes, options) {
    return categorizeSelectorNodes(nodes, options).reduce(function (previous, current) {
        var _a;
        return (tslib_1.__assign(tslib_1.__assign({}, previous), (_a = {}, _a[current] = (previous[current] || 0) + 1, _a)));
    }, {});
};
var specificityFromSelectorNodes = function (nodes, options) {
    var counted = countNodeTypes(nodes, options);
    return [counted.id || 0, counted.class || 0, counted.element || 0];
};
var calculateSpecificity = function (selector, options) {
    var parsed = typeof selector === 'string' ? (0, css_selector_tokenizer_1.parse)(selector) : selector;
    if (parsed.nodes.length > 1)
        throw Error('Too many selectors.');
    var selectorNode = parsed.nodes[0];
    if (selectorNode.type !== 'selector')
        throw Error('Not a selector.');
    return specificityFromSelectorNodes(selectorNode.nodes, options);
};
exports.calculateSpecificity = calculateSpecificity;
var matchSpecificity = function (a, b) {
    var length = 3;
    for (var i = 0; i < length; i++) {
        if (a[i] < b[i]) {
            return -1;
        }
        else if (a[i] > b[i]) {
            return 1;
        }
    }
    return 0;
};
exports.matchSpecificity = matchSpecificity;
//# sourceMappingURL=selector-specificity.js.map